const Portuguese = require("flatpickr/dist/l10n/pt.js").default.pt;
declare var webApp: any;

webApp.pages.solicitarReembolso = {};
const SolicitarReembolso = webApp.pages.solicitarReembolso;
(window as any).SolicitarReembolso = SolicitarReembolso;

SolicitarReembolso.multipleDate = function () {

    flatpickr("#date-multiple",
        {
            mode: "multiple",
            dateFormat: "d/m/Y",
            maxDate: "today",
            "locale": Portuguese,
        }
    );    
}

SolicitarReembolso.getDates = function () {

    let dates = document.getElementById("date-multiple") as HTMLInputElement;

    return dates.value;
}

SolicitarReembolso.cleanDates = function () {

    let dates = document.getElementById("date-multiple") as HTMLInputElement;

    dates.value = ""
}
